<template>
    <div>
        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start pt-1 sm:pt-3 pb-1 sm:pb-2">
          <label :for="id" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
            {{label}}
          </label>

          <Switch :id="id" :modelValue="modelValue" @click="valueChanged" class="mt-1" :readonly="readonly" :class="[modelValue ? 'bg-blue-500' : 'bg-gray-200', 'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500']">
            <span class="sr-only">Use setting</span>
            <span aria-hidden="true" :class="[modelValue ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200']" />
          </Switch>
        </div>
    </div>
</template>

<script>
import { Switch } from '@headlessui/vue'

export default {
    components: {
      Switch
    },
    computed: {
      hasSlot: function() {
        return this.$slots.default;
      },
      isMultiError: function() {
        return this.error && Array.isArray(this.error)
      }
    },
    props: [
        'id',
        'label',
        'modelValue',
        'readonly'
    ],
    methods: {
      valueChanged() {
        if (!this.readonly) {
          this.$emit('update:modelValue', !this.modelValue)
        }
      }
    }
};
</script>